import React, { Component } from 'react'
import LoadingLogo from '../../images/loadinglogo.PNG'
import Spinner from '../../images/spinner.png'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Box, Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

function LinearProgressWithLabel (props) {
  return (
    <Box display='flex' alignItems='center'>
      <Box width='100%' mr={1}>
        <LinearProgress variant='determinate' {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant='body2' color='textSecondary'>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

function CircularProgressWithLabel (props) {
  return (
    <Box position='relative' display='inline-flex'>
      <CircularProgress
        variant='determinate'
        {...props}
        size={100}
        style={{ color: 'red' }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Typography
          variant='caption'
          component='div'
          color='textSecondary'
          style={{ fontSize: '2rem' }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

export class NonPoModal extends Component {
  render () {
    return (
      <div id='modalBody' className='modalBody'>
        {/* <LinearProgressWithLabel value={this.props.progress} /> */}
        <div className='modalContainer'>
          <div className='modalbg2' onClick={this.props.closeReturnModal} />

          <div
            className='modalContent2'
            style={{
              display: 'grid',
              margin: 'auto',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              width: '100vw'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <CircularProgressWithLabel value={this.props.progress} />
              <br />
              <Typography variant='body1' align='center'>
                Please wait
              </Typography>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NonPoModal
